// Constantes partagées entre la sphère des alphabets (sillageMain.js,
// alphabetSphere.js) et la page de réglage admin (sillage-sphere-tuning.html)
// -- valeurs pures (pas de dépendance à THREE), importables aussi bien côté
// navigateur que côté service Node (sphereSettingsService.js) pour n'avoir
// qu'un seul endroit où ces valeurs par défaut sont définies.

// Ordre des 11 écritures = clés SCRIPT_CONFIG de src/detectScript.js (champ
// `script` des punchlines en base). Ne pas réordonner sans mettre à jour
// les deux en même temps. Jpan ajouté en fin de liste (24 septembre 2026) :
// APPENDED plutot qu'insere au milieu pour ne decaler l'index d'aucune
// ecriture existante (indexOf('Latn')/indexOf('Hang') dans alphabetSphere.js
// restent valides) -- mais la position des ancrages SUR la sphere (Fibonacci,
// alphabetSphere.js) depend du nombre total d'ecritures : passer de 10 a 11
// redistribue legerement TOUS les ancrages, pas seulement le nouveau
// (couleurs inchangees en revanche, cf. commentaire ALPHABET_COLORS).
export const SCRIPT_ORDER = ['Latn', 'Arab', 'Deva', 'Hani', 'Cyrl', 'Beng', 'Hebr', 'Thai', 'Hang', 'Grek', 'Jpan'];

export const ALPHABET_LABELS = {
  Latn: 'Latin', Arab: 'Arabe', Deva: 'Devanagari', Hani: 'Chinois', Cyrl: 'Cyrillique',
  Beng: 'Bengali', Hebr: 'Hébreu', Thai: 'Thaï', Hang: 'Coréen', Grek: 'Grec', Jpan: 'Japonais',
};

// "Look" de la sphère : tout ce que la page de réglage peut sauvegarder et
// que sillage.html applique au chargement. Ne contient PAS les poids par
// alphabet (uWeights) : ceux-là viennent toujours des vraies données
// (nombre de punchlines par `script`), jamais d'un fichier de réglages.
export const DEFAULT_SPHERE_SETTINGS = {
  particlesX: 50,
  particlesY: 50,
  density: 2.5,
  tightness: 1.25,
  fScale: 0.5,
  complexity: 5,
  octMult: 0.5,
  octScale: 1.5,
  displace: 1.5,
  flow: 0.025,
  pointSize: 0.035,
  opacity: 0.5,
  sigmaBase: 1,
  rotSpeed: 0.075,
  // Inclinaison fixe de l'axe de rotation, en degrés (comme l'axe terrestre
  // à ~23°) : la sphère tourne en continu sur Y autour de cet axe incliné,
  // pas de tangage/oscillation -- juste un axe de rotation qui n'est plus
  // parfaitement vertical.
  tilt: 23.4,
  // Pas de post-processing bloom : sillage.html n'a pas de pipeline
  // EffectComposer et on ne voulait pas d'écart entre "ce qu'on règle dans
  // l'outil" et "ce qui s'affiche vraiment en prod" (cf. passation) -- le
  // glow vient du blending additif + uRimBoost, pas d'un vrai bloom.
  scale: 0.85, // dans sillage.html : proportion du rayon du globe (radius = SPHERE_RADIUS * scale)
  contain: 0.05,
  feather: 0.025,
  rimBoost: 0.5,
  // Nombre de punchlines à partir duquel un territoire approche sa taille
  // maximale (saturation exponentielle, jamais de coupure nette même avec
  // des milliers de dépôts pour un même alphabet -- voir alphabetSphere.js).
  weightScale: 40,
};
